import { FaFacebook, FaShopify } from 'react-icons/fa'

const VENDOR_ICONS = {
  Facebook: { icon: FaFacebook },
  Shopify: { icon: FaShopify }
}

export { VENDOR_ICONS }
